import { render, staticRenderFns } from "./AlertarPersonalizado.vue?vue&type=template&id=46ab1908&"
import script from "./AlertarPersonalizado.vue?vue&type=script&lang=js&"
export * from "./AlertarPersonalizado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports